<template>
  <div class="standart-page">
    <b-modal
      id="modal-cancel-confirm"
      centered
      title="Uyarı"
      header-bg-variant="warning"
      header-text-variant="light"
      ok-variant="success"
      ok-title="Tamam"
      cancel-variant="outline-secondary"
      cancel-title="Vazgeç"
      @ok.prevent="$router.go(-1)"
    >
    </b-modal>
    <div class="row mb-3">
      <div class="col-3"></div>
      <div class="col d-flex align-items-center justify-content-center">
        <h3 class="title mb-0">{{ $store.state.rb.detail.pageTitle }}</h3>
      </div>
      <div class="col-3 d-flex justify-content-end align-items-center">
        <button class="btn btn-outline-secondary back-button" @click="goBack">
          <font-awesome-icon icon="angle-double-left" class="mr-2" />
          Listeye Geri Dön
        </button>
      </div>
    </div>
    <component :is="$store.state.rb.detail.currentComp" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    goBack() {
      if (this.isChanged) {
        this.$bvModal.show("modal-cancel-confirm");
      } else {
        this.$router.go(-1);
      }
    }
  },
  created() {
    // if(this.$route.params.rtid == 1)//ÜYE
    //   console.log("ok1");
    // else 
    if(this.$route.params.rtid == 2)//MÜZİK ESERİ
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.meComp;
    else if(this.$route.params.rtid == 3)//MÜZİK YAPIMI
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.myComp;
    else if(this.$route.params.rtid == 4)//MÜZİK İCRASI
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.miComp;
    else if(this.$route.params.rtid == 5)//SİNEMA ESERİ
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.seComp;
    else if(this.$route.params.rtid == 6)//SİNEMA YAPIMI
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.syComp;
    else if(this.$route.params.rtid == 7)//SİNEMA İCRASI
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.siComp;
    else if(this.$route.params.rtid == 8)//GÜZEL SANAT ESERİ
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.gsComp;
    else if(this.$route.params.rtid == 9)//İLİM EDEBİYAT ESERİ
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.ieComp;
    else if(this.$route.params.rtid == 10)//İLİM EDEBİYAT YAYINI BANDROL MUAF
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.imComp;
    else if(this.$route.params.rtid == 11)//ÇEVİRİ ESERİ
      this.$store.state.rb.detail.currentComp = this.$store.state.rb.detail.ceComp;

    this.$store.state.rb.recordId = 0;
  },
  computed: {
    ...mapGetters("general", ["getMessage"]),
  },
  watch: {},
};
</script>